/**
 * @file       Logout reason constants for post-logout login UX
 * @version    2.0.0
 * @author     Boris Veits
 * @copyright  Copyright (c) 2018, MindShare HDV LLC.  All rights reserved.
 *             Property of MindShare HDV LLC.  This file cannot be used or
 *             altered in anyway without expressed written permission from
 *             MindShare HDV LLC.
 */

const LOGOUT_REASON =
{
    IDLE: 'idle',
    SESSION_EXPIRED: 'sessionExpired',
    MANUAL: 'manual'
} as const;

const LOGOUT_QUERY_PARAM = 'reason';

const LOGOUT_MESSAGE =
{
    [LOGOUT_REASON.IDLE]:
        'Your session timed out due to inactivity. '
        + 'Please sign in again.',
    [LOGOUT_REASON.SESSION_EXPIRED]:
        'Your session has expired. Please sign in again.'
} as const;

export
{
    LOGOUT_REASON,
    LOGOUT_QUERY_PARAM,
    LOGOUT_MESSAGE
};
